/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';
import {
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
  Button,
} from '@mui/material';
import { useGetCompanyManagerListLazyQuery, useAddCompanyManagerMutation } from '../../../../../graphql/generated/graphql';

import { setAddCompanyManager, useCompanyInfoState } from '../../../../hooks/companyInfo';
import { CompanyManager } from '../../../../config/interfaces';
import ListCompanyManagers from './list-company-managers';

export default function AddCompanyManager() {
  const [getCompanyManager, { data }] = useGetCompanyManagerListLazyQuery();
  const [addManager] = useAddCompanyManagerMutation();
  const companyState = useCompanyInfoState();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [valueAuto, setValueAuto] = useState<string | null>();
  let options: CompanyManager[] = [];
  const loading = open && options.length === 0;
  const companyManagers = companyState.company_managers.get();

  const addCompManagerRef = useRef<any>()
  const clearFieldAddCompManager = () => {
    const buttonClean = addCompManagerRef.current.querySelector('button')
    buttonClean.click();
  }

  const onSubmit = async () => {
    setLoader(true);
    try {
      const response = await addManager({
        variables: {
          user_id: valueAuto as string,
        },
      });
      setAddCompanyManager(
        response.data?.addCompanyManager as CompanyManager,
      );
      setValueAuto(null);
      clearFieldAddCompManager();
      setLoader(false);
    } catch (e) {
      console.error(e);
    }
  };

  const onChangeHandle = async (value: string) => {
    getCompanyManager({
      variables: {
        name_or_email: value,
      },
    })
  };

  if (data) {
    options = data.getCompanyManagerList as CompanyManager[];
  }

  useEffect(() => {
    if (!open) {
      const temp: CompanyManager[] = [];
      options = [...temp];
    }
  }, [open]);

  return (
    <>
      <Grid
        sx={{
          width: '100%',
          display: 'flex',
          my: 2,
        }}
      >
        <Autocomplete
          id="company-managers"
          ref={addCompManagerRef}
          sx={{
            width: '700px',
            maxWidth: '90%',
            mr: 1,
            display: 'flex',
          }}
          open={open}
          options={options}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          renderOption={(props, option) => (
            <li {...props}>
              {option.full_name}
            </li>
          )}
          onChange={(event: any, newValue: CompanyManager | null | undefined) => setValueAuto(newValue?.id)}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.email}  ${option.full_name}`}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Type a name or a co-worker’s email"
              onChange={(ev) => {
                if (ev.target.value !== '' || ev.target.value !== null) {
                  onChangeHandle(ev.target.value);
                }
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={!valueAuto}
          onClick={onSubmit}
          sx={{
            width: '135px',
          }}
        >
          {loader ? (
            <CircularProgress color="primary" />
          ) : (
            'Add'
          )}
        </Button>
      </Grid>
      { companyManagers && (
        <Grid
          sx={{
            width: '100%',
            mt: 4,
          }}
        >
          {companyManagers.map((manager, index) => (
            <ListCompanyManagers key={manager.id} idx={index} manager={manager} />
          ))}
        </Grid>
      )}
    </>
  );
}
